var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{attrs:{"type":_vm.type},on:{"click":function($event){return _vm.downLoadCenter({ sign: _vm.sign, params: _vm.params, tips: _vm.tips })}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }